import src from "IMAGE";
export default { src, width: 1668, height: 273, blurWidth: 0, blurHeight: 0};
